import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { FORMAT_TEXT_COMMAND } from "lexical";
import React, { useCallback } from "react";

type HtmlEditorToolBarType = {
  isBold: boolean;
  isItalic: boolean;
  isUnderline: boolean;
  editorContainerRef: React.MutableRefObject<HTMLDivElement | null>;
};

const HtmlEditorToolBar = ({
  isBold,
  isItalic,
  isUnderline,
  editorContainerRef
}: HtmlEditorToolBarType) => {
  const [editor] = useLexicalComposerContext();

  const onBoldClick = useCallback(
    (e: React.MouseEvent | React.TouchEvent) => {
      e.preventDefault();
      editorContainerRef.current?.focus();
      // styles arn't applied if the editor doesn't have focus, this is the only way I found for mobile devices.
      setTimeout(() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold");
      }, 300);
    },
    [editor, editorContainerRef]
  );

  const onItalicClick = useCallback(
    (e: React.MouseEvent | React.TouchEvent) => {
      e.preventDefault();
      editorContainerRef.current?.focus();
      setTimeout(() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic");
      }, 300);
    },
    [editor, editorContainerRef]
  );

  const onUnderlineClick = useCallback(
    (e: React.MouseEvent | React.TouchEvent) => {
      e.preventDefault();
      editorContainerRef.current?.focus();
      setTimeout(() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline");
      }, 300);
    },
    [editor, editorContainerRef]
  );

  return (
    <div className="Toolbar flex bg-[var(--pageBackgroundSecondary)] mb-2">
      <button
        className={[
          "ToolButton",
          "flex justify-center items-center m-2 ml-2 mb-2 mt-2",
          isBold
            ? "Selected text-[var(--primaryColor)] bg-[var(--panelBackground)]"
            : "text-[var(--tertiaryColor)] bg-[var(--pageBackgroundSecondary)]"
        ].join(" ")}
        onMouseDown={onBoldClick}
        onTouchStart={onBoldClick}
      >
        <b className="p-1">B</b>
      </button>
      <button
        className={[
          "ToolButton",
          "flex justify-center items-center m-2 ml-2 mb-2 mt-2",
          isItalic
            ? "Selected text-[var(--primaryColor)] bg-[var(--panelBackground)]"
            : "text-[var(--tertiaryColor)] bg-[var(--pageBackgroundSecondary)]"
        ].join(" ")}
        onMouseDown={onItalicClick}
        onTouchStart={onItalicClick}
      >
        <i className="p-1">I</i>
      </button>
      <button
        className={[
          "ToolButton",
          "flex justify-center items-center m-2 ml-2 mb-2 mt-2",
          isUnderline
            ? "Selected text-[var(--primaryColor)] bg-[var(--panelBackground)]"
            : "text-[var(--tertiaryColor)] bg-[var(--pageBackgroundSecondary)]"
        ].join(" ")}
        onMouseDown={onUnderlineClick}
        onTouchStart={onUnderlineClick}
      >
        <u className="p-1">U</u>
      </button>
    </div>
  );
};

export default React.memo<HtmlEditorToolBarType>(HtmlEditorToolBar);
